import { Photo, Series } from '@types';

export const isSeriesCover =
  (series: Series) =>
  ({ seriesIds, seriesCover }: Photo) =>
    seriesIds?.includes(series.id) &&
    (Array.isArray(seriesCover)
      ? seriesCover.includes(series.id)
      : !!seriesCover);
